<template>
  <div class="dialog-unlock">
    <van-dialog v-model="dailogShow" title="积分解锁" :show-confirm-button="false">
      <div class="di_content">您将消耗{{ dataProps && dataProps.unlockCost }}积分兑换该{{ dataProps && dataProps.unlockTxt }},是否确认兑换?</div>
      <div class="di_btn_group">
        <div class="di_btn cancel" v-if="dataProps && dataProps.detailsUnlock" @click.stop="handleGoBack">取消</div>
        <div class="di_btn cancel" v-else @click.stop="() => (dailogShow = false)">取消</div>
        <div class="di_btn ok" @click.stop="handleClickOk">确认</div>
      </div>
    </van-dialog>
    <div class="fail_modal" v-if="showChange">
      <img class="img" :src="changeStatus ? ChangeOk : changeFail" alt="" />
      <p class="msg">{{ changeStatus ? "兑换成功" : "兑换失败" }}</p>
      <p class="tips">{{ exchangeTxt }}</p>
    </div>
  </div>
</template>
<script>
import { unlockTraining } from '@/api/training'
import ChangeOk from '@/assets/train/change_ok.png'
import changeFail from '@/assets/train/change_fail.png'
export default {
  name: 'dialogUnlock',
  props: {
    dataProps: {
      type: Object,
    }
  },
  data() {
    return {
      ChangeOk,
      changeFail,
      dailogShow: false,
      showChange: false,
      changeStatus: false,
      exchangeTxt: ''
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    handleGoBack() {
      if (this.$router.history.current.length > 1) {
        this.$router.go(-1)
      } else {
        // 执行其他操作，比如跳转到首页或退出应用
        this.$router.push('/home')
      }
    },
    handleClickOk () {
      this.dailogShow = false
      let params = {
        openId: this.userInfo.iepOpenId,
        userId: this.userInfo.id,
        baseId: this.dataProps.baseId,
        type: 2,
        unlockMethod: 1,
        unlockCost: this.dataProps.unlockCost,
        unlockContent: `${this.dataProps.unlockContent}`
      }
      unlockTraining(params).then(res => {
        this.exchangeTxt = res.msg
        this.changeStatus = true
        this.showChange = true
        setTimeout(() => {
          this.showChange = false
          // this.handleGotoDetails()
          this.$emit('unlockSuccess')
        }, 1000)
      }).catch((err) => {
        this.changeStatus = false
        this.exchangeTxt = err.msg
        this.showChange = true
        setTimeout(() => {
          this.showChange = false
        }, 1000)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.van-dialog {
  width: 320px;
  height: 195px;
  background: #fff;
  border-radius: 10px;
  &.di_dialog {
    height: auto;
  }

  /deep/.van-dialog__header {
    font-family: Source Han Sans CN, Source Han Sans CN;
    color: #000000;
    font-weight: 600;
    font-size: 17px;
    padding-top: 15px;
    line-height: 24px;
  }
}

.di_content {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
  padding: 28px 26px;
  box-sizing: border-box;
  line-height: 21px;
}

.di_btn_group {
  display: flex;
  padding: 0 17px;
  box-sizing: border-box;
  justify-content: space-between;

  .di_btn {
    width: 130px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    border-radius: 20px 20px 20px 20px;
  }

  .ok {
    background: #EB1700;
    box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
    color: #fff;
  }

  .cancel {
    background: rgba(0, 0, 0, 0.08);
    color: #7a8494;
  }
}

.fail_modal {
  width: 200px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 19px 19px 19px 19px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 24px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 9999;

  .img {
    width: 42px;
    width: 42px;
    margin-bottom: 15px;
  }

  .msg {
    width: 100%;
    text-align: center;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 600;
    font-size: 17px;
    line-height: 20px;
    color: #ffffff;
    margin-bottom: 4px;
  }

  .tips {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialogUnlock.vue